export default "__VITE_ASSET__y5dgv2jf__"